module.exports = __webpack_public_path__ + "img/2price.7843dc6b.png";